import type { ComponentProps } from "react";
import { Toaster as Sonner } from "sonner";

// Meldingen rechtsonder, donkerblauw zoals vroeger; een fout in donkerrood.
function Toaster(props: ComponentProps<typeof Sonner>) {
  return (
    <Sonner
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: "rounded-xl border-0 !bg-navy-950 !text-white shadow-pop",
          title: "text-xs font-bold",
          description: "text-[11px] !text-white/70",
          error: "!bg-[#6e2a2a]",
          icon: "text-blush"
        }
      }}
      {...props}
    />
  );
}

export { Toaster };
